export const APP_VERSION_EVENT = 'app-version-detected';
export const APP_VERSION_HEADER = 'x-app-version';
const APP_VERSION_EVENT_TTL_MS = 60 * 1000;

let lastDispatchedVersion = '';
let lastDispatchedAt = 0;

export function normalizeAppVersion(version) {
    if (version === null || version === undefined) {
        return '';
    }

    return String(version).trim();
}

export function getInitialAppVersion() {
    if (typeof window === 'undefined' || typeof window.appVersion === 'undefined') {
        return '';
    }
    return normalizeAppVersion(window.appVersion);
}

export function versionsDiffer(currentVersion, nextVersion) {
    const current = normalizeAppVersion(currentVersion);
    const next = normalizeAppVersion(nextVersion);

    if (!current || !next) {
        return false;
    }

    return current !== next;
}

export function getAppVersionFromResponse(response) {
    if (!response) {
        return '';
    }

    const headerVersion = response.headers ? response.headers[APP_VERSION_HEADER] : '';
    if (headerVersion) {
        return normalizeAppVersion(headerVersion);
    }

    if (response.data && typeof response.data === 'object' && response.data.version) {
        return normalizeAppVersion(response.data.version);
    }

    return '';
}

export function dispatchDetectedAppVersion(version) {
    const normalizedVersion = normalizeAppVersion(version);
    if (!normalizedVersion || typeof window === 'undefined') {
        return;
    }

    const now = Date.now();
    if (normalizedVersion === lastDispatchedVersion && now - lastDispatchedAt < APP_VERSION_EVENT_TTL_MS) {
        return;
    }

    lastDispatchedVersion = normalizedVersion;
    lastDispatchedAt = now;

    window.dispatchEvent(
        new CustomEvent(APP_VERSION_EVENT, {
            detail: {
                version: normalizedVersion,
            },
        })
    );
}
